import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControl } from '@ngneat/reactive-forms';
import { emailWithTldValidator } from '../../../../validators/email-with-tld.validator';
import { numberValidator } from '../../../../validators/number.validator';
import { InputBlockPayload } from '../../types/input-block-payload.interface';
import { InputType } from '../../types/input-type.enum';
import { BlockComponent } from '../block/block.component';
import { FormControlIconDirective } from '../../../form-control/directives/form-control-icon.directive';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { FormControlHintDirective } from '../../../form-control/directives/form-control-hint.directive';
import { TextareaAutosizeDirective } from '../../../../directives/textarea-autosize.directive';
import { FormControlInputDirective } from '../../../form-control/directives/form-control-input.directive';
import { FormControlLabelDirective } from '../../../form-control/directives/form-control-label.directive';
import { FormControlComponent } from '../../../form-control/components/form-control/form-control.component';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

const SHORT_TEXT_MAX_LENGTH = 100;
const LONG_TEXT_MAX_LENGTH = 300;

@Component({
  selector: 'app-input-block',
  templateUrl: './input-block.component.html',
  styleUrls: ['./input-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    FormControlComponent,
    FormControlLabelDirective,
    FormsModule,
    FormControlInputDirective,
    TextareaAutosizeDirective,
    ReactiveFormsModule,
    FormControlHintDirective,
    NgSwitch,
    SvgIconComponent,
    FormControlIconDirective,
    NgSwitchCase,
    NgSwitchDefault,
  ],
})
export class InputBlockComponent extends BlockComponent<InputBlockPayload, undefined> implements OnInit {
  public readonly InputType = InputType;
  public formControl = new FormControl('');

  public ngOnInit(): void {
    switch (this.payload.type) {
      case InputType.ShortText: {
        this.formControl.setValidators([Validators.maxLength(SHORT_TEXT_MAX_LENGTH)]);
        break;
      }
      case InputType.LongText: {
        this.formControl.setValidators([Validators.maxLength(LONG_TEXT_MAX_LENGTH)]);
        break;
      }
      case InputType.Email: {
        this.formControl.setValidators([emailWithTldValidator]);
        break;
      }
      case InputType.Numeric: {
        this.formControl.setValidators([numberValidator()]);
        break;
      }
    }

    this.register.next(this.formControl);
  }
}
